import { Component, OnInit, Input } from '@angular/core';
import { HomeService } from 'src/app/core/http/web/home.service';
import { environment as params } from 'src/environments/environment';
import * as moment from 'moment';

declare var $: any;

@Component({
  selector: 'app-promo',
  templateUrl: './promo.component.html',
  styleUrls: ['./promo.component.scss']
})
export class PromoComponent implements OnInit {
  public popup: any = null;
  urlBaseS3: any = (<any>params).api.s3;
  @Input('loadServ') public loadServ: boolean = true;
  @Input('data') public data: any;
  constructor(private _homeService: HomeService) {}

  ngOnInit() {}

  ngAfterContentInit(): void {
    if (this.loadServ) {
      this.getGeneralOptions();
    } else {
      this.loadinfo(this.data);
    }
  }

  getGeneralOptions() {
    this._homeService.getGeneralOptions().subscribe(
      data => {
        console.log('POPUP:', data.data.modals.popup);
        this.loadinfo(data.data);
      },
      err => {
        console.error(err);
      }
    );
  }
  loadinfo(data) {
    let self = this;
    if (
      !(
        data &&
        data.modals &&
        data.modals.popup &&
        JSON.stringify(data.modals.popup).length > 3
      )
    ) {
      console.warn('Sin data popup');
    } else {
      this.popup = data.modals.popup;
      setTimeout(() => {
        self.openModal();
      }, 100);
    }
  }

  openModal(): void {

    let inicio = false, fin = false;

    let start =
      this.popup.vigencia_start && this.popup.vigencia_start.length > 0
        ? new Date(this.popup.vigencia_start)
        : new Date('invalid');

    if (start.toString() === 'Invalid Date') {
      start = new Date();
      start.setDate(start.getDate() - 1);
      inicio = true;
    }

    let end =
      this.popup.vigencia_end && this.popup.vigencia_end.length > 0
        ? new Date(this.popup.vigencia_end)
        : new Date('invalid');

    if (end.toString() === 'Invalid Date') {
      end = new Date();
      end.setDate(end.getDate() + 1);
      fin = true;
    }

    let compareDate = new Date();

    //Se encuentra en el rango
    if (start < compareDate && (!inicio || !fin) ) {
      if (compareDate < end) {
        $('#promoModal').modal('show');
      }
    }
  }

  locationHref(url) {
    window.location.href = url;
  }
}
